import React from "react";
import {connect} from "react-redux";
import {Query} from "react-apollo";
import ActionButton from "../../../components/ActionButton";
import {requestEditPartnerAddress} from "../../../actions/PartnerApiActions";
import {rolesTitle} from "../roleLabels";
import "./PartnerPropertiesPanel.scss";
import {fromJS, List} from "immutable";
import PanelGroupController from "../../../components/PanelGroupController";
import PropertiesList from "../../../components/panels/PropertiesList";
import Loading from "../../../components/Loading";
import GraphQLErrors from "../../../components/GraphQLErrors";
import {GET_PARTNER} from "../../../queries/partners";

const properties = fromJS([
  {prop: "name", label: "Name", type: "string"},
  {prop: "partnerId", label: "Id", type: "id"},
  {prop: "roles", label: "Roles", type: "array"},
  {prop: "contactName", label: "Contact", type: "string"},
  {prop: "email", label: "Email", type: "string"},
  {prop: "phone", label: "Phone", type: "string"},
  {prop: "active", label: "Active", type: "boolean"},
  {prop: "notes", label: "Notes", type: "string"},
  {prop: "updatedAt", label: "Updated", type: "utc"},
]);

function addressLines(address) {
  return [
    address.get("name"),
    address.get("attName") ? `Att. ${address.get("attName")}` : "",
    address.get("addressLine1"),
    address.get("addressLine2"),
    [address.get("postcode"), address.get("city")].filter((part) => part).join(" "),
    address.get("stateProvince"),
    address.get("countryCode"),
    address.get("phoneNr"),
    address.get("email"),
  ].filter((line) => line);
}

// Titled by the selected one's roles: Client, Supplier, or Client & Supplier.
const PartnerPropertiesPanel = (props) => {
  if (!props.partnerId) {
    return (
      <PanelGroupController title="Client or Supplier" expanded={props.expanded}>
        <p className="u-no-selection">Nothing selected</p>
      </PanelGroupController>
    )
  }

  return (
    <Query query={GET_PARTNER} variables={{partnerId: props.partnerId}} fetchPolicy="cache-and-network">
      {({loading, error, data}) => {
        const found = data && data.partner;
        let content;
        if (loading && !found) content = <Loading />
        else if (error) content = <GraphQLErrors error={error} />
        else {
          const partner = fromJS(found);
          content = (
            <React.Fragment>
              <PropertiesList properties={properties} data={partner} />
              {partner.get("addresses", List()).map((address) => (
                <div className="PartnerAddress" key={address.get("addressId")}>
                  <div className="header">
                    <strong>{address.get("label")}</strong>
                    <ActionButton label="Edit" primary={false}
                      onClick={() => props.requestEditPartnerAddress(props.partnerId, address.get("addressId"))} />
                  </div>
                  {addressLines(address).map((line, i) => <div key={i}>{line}</div>)}
                </div>
              ))}
            </React.Fragment>
          )
        }

        return (
          <PanelGroupController title={rolesTitle(found && found.roles)} expanded={props.expanded}>
            {content}
          </PanelGroupController>
        )
      }}
    </Query>
  )
}

export default connect(null, {requestEditPartnerAddress})(PartnerPropertiesPanel);
